import { render } from "./wms-romaneio-editar.vue?vue&type=template&id=27ff49a1"
import script from "./wms-romaneio-editar.vue?vue&type=script&lang=js"
export * from "./wms-romaneio-editar.vue?vue&type=script&lang=js"

import "./wms-romaneio-editar.vue?vue&type=style&index=0&id=27ff49a1&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__